import { AccessGate } from '../../shared/access/AccessControls';
import { useAllowedMutation } from '../../shared/access/AccessControls';
import React, { useEffect } from 'react';
import MainLayout from '../../shared/components/MainLayout';
import { Button, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { toPrettyDate } from '../../shared/utils/utils';
import { StyledActionsRow, StyledFiltersWrapper } from './styled';
import ResponsiveTable from '../../shared/components/table/ResponsiveTable';
import Card from '../../shared/components/ui/Card/Card';
import IntegrationDefinitionModal from './IntegrationDefinitionModal';
import { useSelector } from 'react-redux';

import AlertDialog from '../../shared/components/custom/AlertDialog/AlertDialog';
import { integrationDefinitionsApi } from '../../store/services/IntegrationDefinitionsService';
import { selectIntegrationDefinitions } from '../../store/slices/integrationDefinitionSlice';

const IntegrationDefinitions = () => {
  const [trigger] = integrationDefinitionsApi.useLazyGetRolesQuery();
  const roles = useSelector(selectIntegrationDefinitions);
  const [deleteRole] = useAllowedMutation(integrationDefinitionsApi.useDeleteIntegrationDefinitionMutation, 'deleteIntegrationDefinition');

  const onDelete = (roleId: string) => () => {
    deleteRole({ roleId });
  };

  useEffect(() => {
    trigger({});
  }, [trigger]);

  return (
    <MainLayout>
      <StyledFiltersWrapper>
        <Text as="h1">Integration definitions</Text>
        <IntegrationDefinitionModal
          activator={<Button colorScheme="blue">Create</Button>}
        />
      </StyledFiltersWrapper>

      <Card noPadding>
        <ResponsiveTable>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Date</Th>
              <Th style={{ width: 0 }} />
            </Tr>
          </Thead>
          <Tbody>
            {roles.map((role) => (
              <Tr key={role.id}>
                <Td>
                  <div>
                    <p>
                      <b>{role.name}</b>
                    </p>
                    <p>{role.description}</p>
                  </div>
                </Td>
                <Td>
                  Created at{' '}
                  <b>{toPrettyDate(role.createdAt, 'MMM dd, yyyy hh:mm')}</b>
                </Td>
                <Td>
                  <StyledActionsRow>
                    <IntegrationDefinitionModal
                      role={role}
                      activator={<Button size={'sm'}>Edit</Button>}
                    />
                    <AccessGate action="ADMIN_ROLE_DELETE"><AlertDialog
                      title="Delete this integration definition?"
                      confirmLabel={'Delete'}
                      confirmColorScheme={'red'}
                      onConfirm={onDelete(role.id)}
                      activator={
                        <Button size={'sm'} colorScheme={'red'}>
                          Delete
                        </Button>
                      }
                    /></AccessGate>
                  </StyledActionsRow>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </ResponsiveTable>
      </Card>
    </MainLayout>
  );
};

export default IntegrationDefinitions;
